import { render, staticRenderFns } from "./FeedbackComponent.vue?vue&type=template&id=507468a8&"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js&"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackComponent.vue?vue&type=style&index=0&id=507468a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports